import { Data } from "./data";


export class Database extends Data {
  
  description: string;
  remote: string;
  syncMode:string; // offline, onlineSaveMode, online

  constructor() {
    super();
  }


}
